(function ($) {
	// Defined a variable to track the last scroll position
	let lastScrollTop = 0;
	// Listen to the scroll event to track the direction of the users scroll
	window.addEventListener(
		'scroll',
		() => {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop > lastScrollTop) {
				// Visitor is scroll down
				if ($(window).scrollTop() > 160) {
					// Only hide the site-header if visitor has scrolled
					// pass double the height of the site-header
					$('.site-header').addClass('site-header--hide');
					$('.sticky').addClass('sticky--hide');
					$('.site-header').addClass('scrolled');
					$('.sticky').addClass('scrolled');
				}
			} else if (scrollTop <= (lastScrollTop - 20)) {
				// Visitor is scrolling up remove the hidden class
				$('.site-header').removeClass('site-header--hide');
				$('.sticky').removeClass('sticky--hide');
			}

			if ($(window).scrollTop() <= 160) {
				$('.site-header').removeClass('scrolled');
				$('.sticky').removeClass('scrolled');
			}

			// Update our scroll position
			lastScrollTop = scrollTop;
		},
		false,
	);
}(jQuery));
